







































import { Component, PropSync, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class XBtnActiveInActive extends Vue {
  @PropSync("view") icon!: any;
}
